import type { FC } from 'react';

import type { ActionLogEntry } from '@/types';
import { groupByDay, type ActionLogDayGroup } from '../model';
import { ActionTimelineDayGroupView } from './ActionTimelineDayGroup';
import { ActionLogEmpty } from './ActionLogEmpty';
import styles from './ActionTimeline.module.css';

interface ActionTimelineProps {
  entries?: ActionLogEntry[];
  groups?: ActionLogDayGroup[];
  emptyHint?: string;
}

export const ActionTimeline: FC<ActionTimelineProps> = ({
  entries = [],
  groups: providedGroups,
  emptyHint,
}) => {
  const groups = providedGroups ?? groupByDay(entries);

  if (groups.length === 0) {
    return <ActionLogEmpty hint={emptyHint} />;
  }

  return (
    <div className={styles.timeline}>
      {groups.map((group) => (
        <ActionTimelineDayGroupView key={group.date} group={group} />
      ))}
    </div>
  );
};
